import { render, staticRenderFns } from "./SectionTestimonials.vue?vue&type=template&id=67e89137&scoped=true&"
import script from "./SectionTestimonials.vue?vue&type=script&lang=js&"
export * from "./SectionTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./SectionTestimonials.vue?vue&type=style&index=0&id=67e89137&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e89137",
  null
  
)

export default component.exports